// extracted by mini-css-extract-plugin
export var link = "styles-module--link--648a4";
export var ratingValue = "styles-module--ratingValue--c4808";
export var siteReviewContainer = "styles-module--siteReviewContainer--4df99";
export var title = "styles-module--title--1f59d";